export const TITLE_FONT_SIZE = '1.75rem';
